// AcsTrack.js - Client-side Tracking for ACS Impressions and Clicks

document.addEventListener('DOMContentLoaded', () => {
    if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('[data-acs-widget-id]').forEach(fireAcsImpressionOnce);
        return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
        for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const widget = entry.target;

            // Ensure single-fire per widget
            if (widget.dataset.acsImpressionFired === '1') {
                obs.unobserve(widget);
                continue;
            }

            fireAcsImpressionOnce(widget);
            widget.dataset.acsImpressionFired = '1';
            obs.unobserve(widget); // stop observing after first fire
        }
    },
        {
            root: null,
            rootMargin: '0px',
            threshold: 0 //fire immediately, can update to 10%, 50%, 100% etc. to fire when that much of the widget is in view
        });

    document.querySelectorAll('[data-acs-widget-id]').forEach(w => observer.observe(w)); // Observe widgets
});

function fireAcsImpressionOnce(widget) {
    const token = widget.getAttribute('data-acs-token') || ''
    const widgetId = widget.getAttribute('data-acs-widget-id') || '';
    const widgetPosition = widget.getAttribute('data-acs-widget-position') || '';
    const acsSource = widget.getAttribute('data-acs-source') || '';
    const acsSegments = widget.getAttribute('data-acs-segments') || '';
    const acsType = widget.getAttribute('data-acs-widget-type') || '';

    const acsllId = widget.getAttribute('data-acs-llid') || '';
    const cookiellId = getUserIdFromCookie();
    const displayId = generateGuid();

    const items = [];
    widget.querySelectorAll('[data-acs-item-type]').forEach((item, idx) => {
        const item_position = Number(item.getAttribute('data-acs-item-position')) || (idx + 1);
        items.push({
            position: item_position,
            width: 1,
            height: 1,
            item_type: item.getAttribute('data-acs-item-type') || '',
            item_major_type: item.getAttribute('data-acs-item-major-type') || '',
            item_id: item.getAttribute('data-acs-item-cid') || '',
            item_url: item.getAttribute('data-acs-item-url') || '',
            item_title: item.getAttribute('data-acs-item-title') || ''
        });

        // Setup click event tracking
        item.addEventListener('click', () => {
            postAcsEvent(token, {
                event_type: 'click',
                display_id: displayId,
                item_position: item_position,
                widget_id: widgetId,
                page_key: gaPagekey, //set on page
                session_id: sessionId,    //set on page
                pageview_id: page_view_id//set pn page
            });
        });
    });


    // Log the impression (one per widget)
    postAcsEvent(token, {
        event_type: 'impression',
        display_id: displayId,
        widget_id: widgetId,
        widget_position: widgetPosition,
        page_key: gaPagekey, //set on page
        page_url: window.location.href,
        referral_url: document.referrer,
        pageview_id: page_view_id,//set pn page
        acs_ll_id: acsllId,
        acs_source: acsSource,
        acs_segments: acsSegments,
        acs_widget_type: acsType,
        acs_items_shown: items.length,
        items: items,
        user_info: {
            ll_id: cookiellId,
            session_id: sessionId,    //set on page
            user_agent: navigator.userAgent
        },
    });
}

function postAcsEvent(token, data) {
    //console.log("ACS Event Payload:\n", data);
    ;
    fetch('/TemplateBuilder/AcsTrack.ashx', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-ACS-Token': token },
        body: JSON.stringify(data),
        credentials: 'same-origin',//allows cookie access in handler
        keepalive: true
    })
        .then(res => {
            if (!res.ok) console.error("ACS logging failed:", res.statusText);
        })
        .catch(err => console.error("ACS log error:", err));
}

function getUserIdFromCookie() {
    const name = "polacs_rs=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let c of ca) {
        c = c.trim();
        if (c.indexOf(name) === 0) {
            return c.substring(name.length);
        }
    }
    return null;
}

function generateGuid() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}
